var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7109 0H1.71094C1.44572 0 1.19137 0.105357 1.00383 0.292893C0.816294 0.48043 0.710938 0.734784 0.710938 1V18C0.710938 18.5304 0.921651 19.0391 1.29672 19.4142C1.6718 19.7893 2.1805 20 2.71094 20H24.7109C25.2414 20 25.7501 19.7893 26.1252 19.4142C26.5002 19.0391 26.7109 18.5304 26.7109 18V1C26.7109 0.734784 26.6056 0.48043 26.418 0.292893C26.2305 0.105357 25.9762 0 25.7109 0ZM23.1397 2L13.7109 10.6437L4.28219 2H23.1397ZM24.7109 18H2.71094V3.27375L13.0347 12.7375C13.2192 12.9069 13.4605 13.0008 13.7109 13.0008C13.9614 13.0008 14.2027 12.9069 14.3872 12.7375L24.7109 3.27375V18Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailicon);
export default __webpack_public_path__ + "static/media/mailicon.6da70d987fbb0191f002ff454a88fba3.svg";
export { ForwardRef as ReactComponent };